import React from "react";
import "../scss/faq.css";
import { Helmet } from "react-helmet-async";

const FAQ = () => {
  const faqs = [
    {
      question: "Q: What services does MotoDoctor offer?",
      answer:
        "We help with flat tires, battery jumpstart, towing, fuel delivery, breakdown repairs & full doorstep bike service.",
    },
    {
      question: "How do I request help",
      answer: "Just download the MotoDoctor app, select the service you need & share your location.",
    },
    {
      question: "Q: How quickly can you reach me?",
      answer: "Usually within 30–45 minutes inside Chennai, depending on traffic.",
    },
    {
      question: "Q: Where do you operate?",
      answer: "Currently all over Chennai – and we’re growing!",
    },
    {
      question: "Q: How do I pay",
      answer: "Pay securely via UPI, card, wallet or cash.",
    },
    {
      question: "Q: Can I schedule a service in advance?",
      answer:
        "Yes! Schedule pickup/drop or doorstep service for any date you prefer.",
    },
    {
      question: "Q: Who are your mechanics?",
      answer:
        "Background-verified, trained bike mechanics experienced in multiple brands.",
    },
    {
      question: "Q: What if my bike needs towing?",
      answer:
        "We’ll arrange safe transport to a workshop or your chosen location.",
    },
    {
      question: "Q: How do I track my mechanic?",
      answer:
        "Real-time tracking is available inside the MotoDoctor app.",
    },
    {
      question: "How do I provide feedback about the service?",
      answer:
        "After your service is completed, you’ll receive an option to rate your experience and provide feedback through our app. Your input helps us improve our services.",
    },
    {
      question: "What if I need to cancel or reschedule my service?",
      answer:
        "You can cancel your service through our app or by contacting customer support. Please do so as early as possible. We do not have the facility to reschedule a service for now, but will be coming in the future.",
    },
    {
      question: "How can I contact MotoDoctor for more information?",
      answer:
        "You can reach out to us through our contact form on the website, by phone, or via our social media channels. We are here to assist you with any inquiries.",
    },
  ];
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };
  return (
    <>
      <Helmet>
        {/* TITLE */}
        <title>MotoDoctor - Frequently Asked Questions</title>

        {/* META DESCRIPTION */}
        <meta
          name="description"
          content="Find clear answers to common questions about MotoDoctor’s bike support, emergency help, app usage, service process, pricing, and rider assistance across Chennai."
        />

        {/* CANONICAL (Excel did not include one, so adding correct canonical) */}
        <link rel="canonical" href="https://www.motodoctor.in/faq" />

        {/* H1 */}
        <meta name="heading" content="Frequently Asked Questions" />
      </Helmet>

      <div style={{ marginTop: "60px" }} className="faq-container">
        <h2 className="faq-heading">Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">{faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FAQ;
